import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const WaterConsumptionCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [residents, setResidents] = useState('3');
  const [litersPerDay, setLitersPerDay] = useState('150');
  const [m3Price, setM3Price] = useState('6,50');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const r = parseInt(residents) || 0;
    const l = parseFloat(parseBrazilianNumber(litersPerDay)) || 0;
    const p = parseFloat(parseBrazilianNumber(m3Price)) || 0;
    if (r <= 0 || l <= 0) return;

    const dailyTotal = r * l;
    const monthlyTotal = dailyTotal * 30;
    const m3 = monthlyTotal / 1000;
    const cost = m3 * p;

    const res = { monthlyTotal, m3, cost };
    setResultState(res);
    onResultChange([
      { label: 'Moradores', value: r.toString() },
      { label: 'Consumo (L/mês)', value: `${monthlyTotal.toLocaleString('pt-BR')} L` },
      { label: 'Consumo (m³/mês)', value: `${m3.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} m³` },
      { label: 'Custo Estimado', value: `R$ ${cost.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <FormField label="Nº de Moradores" value={residents} onChange={setResidents} required isInteger type="text" step="1" />
          <FormField label="L/pessoa/dia" value={litersPerDay} onChange={setLitersPerDay} required isNumeric type="text" helpText="Média Brasil: 154L" />
          <FormField label="Preço m³ (R$)" value={m3Price} onChange={setM3Price} required isNumeric type="text" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Consumo de Água
          </button>
        </div>

        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <ResultCard title="Consumo Mensal" value={`${resultState.monthlyTotal.toLocaleString('pt-BR')} L`} color="blue" />
            <ResultCard title="Volume em m³" value={`${resultState.m3.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} m³`} color="slate" />
            <ResultCard title="Custo Estimado" value={`R$ ${resultState.cost.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="indigo" />
          </div>
        )}
      </div>

      <EducationalBlock
        title="Dicas de Consumo Consciente"
        tips={[
          'O consumo ideal por pessoa, segundo a OMS, é de 110 litros por dia',
          'Cheque vazamentos: um vaso sanitário com vazamento pode gastar 50L/dia',
          'Reduza o tempo de banho e feche a torneira ao escovar os dentes',
          'Use a máquina de lavar apenas com carga total para economizar água e energia'
        ]}
      />
    </div>
  );
};

export default WaterConsumptionCalculator;
